module.exports = __webpack_public_path__ + "static/media/Pair.1716154f.jpeg";